import type { TourDefinition } from "../types";

/**
 * Intro for the Product Library. Fires once when the user first opens
 * /app/products. Explains what a "product" means in Zitiu (the thing
 * you will place into scenes) and distinguishes it from the Asset Library.
 */
export const productLibraryTour: TourDefinition = {
  id: "product-library",
  label: "Product Library",
  description: "Where your physical products live",
  routeMatch: /^\/app\/products\/?$/,
  path: "/app/products",
  estimatedSeconds: 45,
  steps: [
    {
      target: "body",
      placement: "center",
      title: "Your Product Library",
      body: "This is where every product you want to photograph lives. A product is the real, physical thing (a sofa, a lamp, a grill) that will be placed into AI-generated scenes.",
    },
    {
      target: '[data-tour="product-library.new"]',
      placement: "bottom-end",
      title: "Add a new product",
      body: "Click here to create a product. You'll pick a product type, fill in details like brand and dimensions, and upload a few reference images.",
    },
    {
      target: '[data-tour="product-library.search"]',
      placement: "bottom-start",
      title: "Find products fast",
      body: "Search by name or brand. Once your library grows, this is the quickest way to jump to a specific product.",
    },
    {
      target: '[data-tour="product-library.grid"]',
      placement: "top",
      title: "Your products live here",
      body: "Click any card to edit its details. Use the ⋯ menu on a card to duplicate or delete.",
      showIf: () => !!document.querySelector('[data-tour="product-library.grid"]'),
    },
  ],
};
